/* unplugin-vue-components disabled */import { render } from "./SpeachResultTable.vue?vue&type=template&id=14610a10&scoped=true&ts=true"
import script from "./SpeachResultTable.vue?vue&type=script&lang=ts"
export * from "./SpeachResultTable.vue?vue&type=script&lang=ts"

import "./SpeachResultTable.vue?vue&type=style&index=0&id=14610a10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14610a10"]])

export default __exports__